import { Colors } from '@sigma-frontend-libs/commons'

import { sizes } from '@/utils'

import tag from '@/components/tag'

function renderCount(h) {
  if (this.isMany) {
    return h(
      tag,
      {
        props: {
          label: `+${this.value.length - this.count}`,
          size: sizes.tiny,
          tooltip: this.countTooltip
        }
      }
    )
  }
}

function renderItem(h, { id, title }) {
  if (typeof title === 'string' && title) {
    return h(
      tag,
      {
        props: {
          label: title,
          size: sizes.tiny,
          color: Colors.info,
          as: 'link',
          to: {
            name: this.name,
            params: { id }
          }
        }
      }
    )
  }
}

function renderItems(h) {
  return this.proxy.slice(0, this.count).map(item => {
    return renderItem.call(this, h, item)
  })
}

export default function(h) {
  return h(
    'div',
    {
      class: 'routes-conditions__condition-value',
      on: {
        click: () => {
          if (this.isMany) {
            this.$emit('click', true)
          }
        }
      }
    },
    [
      renderItems.call(this, h),
      renderCount.call(this, h)
    ]
  )
}
